module.exports = __webpack_public_path__ + "static/media/play-icon.edc52fd7.svg";